// import io from "socket.io-client";

export const LENDER_URL = import.meta.env.VITE_LENDER_URL;
// const socket = io(LENDER_URL);
// console.log(socket);
